const wrapTextNodeInSpan = (element) => {
  const target = element instanceof HTMLElement && !("href" in element || "type" in element) ? element.querySelector("a, button") : element;
  if (!target) return;
  const textNodes = Array.from(target.childNodes).filter(
    (node) => node.nodeType === Node.TEXT_NODE
  );
  textNodes.forEach((node) => {
    const span = document.createElement("span");
    span.textContent = node.textContent?.trim() || "";
    node.replaceWith(span);
  });
  return target;
};
export {
  wrapTextNodeInSpan
};
//# sourceMappingURL=wrapTextNodeInSpan.js.map
